import { atomFamily } from "jotai/utils";

import { AccidentResponsibility, Circumstance } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionVehicleCircumstancePhAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`vehicleCircumstancePh-${sessionId}`, null as Circumstance | null)
);
export const vehicleCircumstancePhAtom = createDerivedSessionAtom<Circumstance | null>(
  sessionVehicleCircumstancePhAtom
);

export const sessionOtherVehicleCircumstanceAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`otherVehicleCircumstance-${sessionId}`, null as Circumstance | null)
);
export const otherVehicleCircumstanceAtom = createDerivedSessionAtom<Circumstance | null>(
  sessionOtherVehicleCircumstanceAtom
);

export const sessionAccidentResponsibilityAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`accidentResponsibility-${sessionId}`, null as AccidentResponsibility | null)
);
export const accidentResponsibilityAtom = createDerivedSessionAtom<AccidentResponsibility | null>(
  sessionAccidentResponsibilityAtom
);
